const { InnerBlocks, RichText } = wp.blockEditor;
import Inspector from './inspector';

const Edit = ({ attributes, setAttributes }) => {
  let ALLOWED_BLOCKS = [
    'base/heading-sumicity',
    'base/paragraph-sumicity',
    'base/button-sumicity',
  ];
  const {
    image,
    variant,
    margin,
    titleCard,
    numberCard,
    removeImage,
    sizeImage,
    hAlign,
    variantColored,
    background,
    originalSize,
    marginImage,
    anchor,
    hasNumber,
  } = attributes;

  let staticDefaultImage;

  if (variant == 'default' || variant == 'withBackground') {
    staticDefaultImage = 'https://via.placeholder.com/80x80';
  } else if (variant === 'defaultHorizontal') {
    staticDefaultImage = 'https://via.placeholder.com/100x100';
  } else if (variant === 'defaultHorizontalBig') {
    staticDefaultImage = 'https://via.placeholder.com/370x300';
  } else if (variant == 'bordered') {
    staticDefaultImage = 'https://via.placeholder.com/300x200';
  } else if (variant == 'borderedHorizontal') {
    staticDefaultImage = 'https://via.placeholder.com/280x280';
  } else if (variant === 'withTopics') {
    ALLOWED_BLOCKS = ['base/heading-sumicity', 'app/topics'];
  } else if (variant === 'withTopicsExtended') {
    staticDefaultImage = 'https://via.placeholder.com/300x75';
    ALLOWED_BLOCKS = [
      'base/heading-sumicity',
      'app/topics',
      'base/button-sumicity',
    ];
  } else if (variant === 'cover') {
    staticDefaultImage = 'https://via.placeholder.com/470x355';
    ALLOWED_BLOCKS = ['base/heading-sumicity', 'app/card-sumicity'];
  } else if (variant === 'coverWithText') {
    staticDefaultImage = 'https://via.placeholder.com/370x300';
  } else {
    staticDefaultImage = '';
  }

  if (variant === 'withTopicsExtended' || variant === 'coverWithText') {
    var style = {
      background: `url(${image.src || staticDefaultImage}) no-repeat`,
      backgroundSize: 'cover',
    };
  }

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <div
        className={`
          Card-col-item wp-editor
          ${variant}
          ${margin}
          ${hAlign}
          ${variant === 'titleColored' ? variantColored : ''}
          ${variant === 'bgColored' && background}
          ${hasNumber === true ? 'hasNumber' : 'withoutNumber'}
        `}
        data-anchor={`${variant === 'coverWithText' ? anchor : ''}`}
      >
        {variant === 'withTopicsExtended' ||
        variant === 'coverWithText' ||
        variant === 'titleColored' ? (
          <div className="Card-col-item-image" style={style}>
            <RichText
              className="Card-col-item-title"
              tagName="h3"
              value={titleCard}
              placeholder="Título aqui"
              keepPlaceholderOnFocus
              onChange={(titleCard) => setAttributes({ titleCard })}
            />
          </div>
        ) : !removeImage && variant != 'circular' ? (
          <figure
            className={`
              Card-col-item-image
              ${marginImage} 
              ${variant === 'bordered' && (originalSize ? 'originalSize' : '')}
              ${sizeImage === 'normal' ? 'imgNormal' : sizeImage === 'big' ? 'imgBig' : ''}
            `}
          >
            <img
              src={image.src || staticDefaultImage}
              alt={image.alt}
              class="Card-col-item-image"
            />
          </figure>
        ) : (
          variant === 'circular' && hasNumber && (
            <div className="Card-col-item-circle">
              <RichText
                className="Card-col-item-number"
                tagName="p"
                value={numberCard}
                placeholder="Título aqui"
                keepPlaceholderOnFocus
                onChange={(numberCard) => setAttributes({ numberCard })}
              />
            </div>
          )
        )}

        {variant != 'coverWithText' && (
          <div className="Card-col-item-text">
            <InnerBlocks allowedBlocks={ALLOWED_BLOCKS} />
          </div>
        )}
      </div>
    </>
  );
};

export default Edit;
